/**
 * BLOCK: Howto - Deprecated Block
 */
/* eslint-disable */
import classnames from "classnames"
import Title from "./components/Title"
import HowToChildDesc from "./components/HowToChildDesc"
import HowToChildPositionClasses from "./classes"
import HowToChildSeparator from "./components/HowToChildSeparator"
import CallToAction from "./components/CallToAction"
import HowToChildIconImage from "./components/HowToChildIconImage"
import attributes from "./attributes"

const {
	RichText
} = wp.blockEditor

const { Fragment } = wp.element

const deprecated = [
    {
        attributes,
        save: function (props) {
	        const {
				iconimgPosition,
				block_id,
				seperatorStyle,
				ctaType,
				ctaLink,
				ctaTarget,
				className,
				howtoChildTitle,
				headingDesc,
				showTitle,
				showDesc,
				seperatorPosition
			} = props.attributes

			// Get Image components.
			let is_image = <HowToChildIconImage attributes={ props.attributes } />

			var icon_image_html = is_image
			var seperator_position = seperatorPosition
			var seperator_html = <HowToChildSeparator attributes={props.attributes} />
			var show_seperator = true

			if( seperatorPosition == "after_icon" && ( iconimgPosition == "above-title" || iconimgPosition == "below-title" ) ){
				show_seperator = false
				icon_image_html = (
					<Fragment>
						{ is_image }
						{ "none" !== seperatorStyle && seperator_html }
					</Fragment>
				)
			}

			if( seperatorPosition == "after_icon" && ( iconimgPosition !== "above-title" || iconimgPosition !== "below-title" ) ){
				seperator_position = "after_title"
			}

			if( iconimgPosition == "below-title" &&  seperatorPosition == "after_title" ){
				show_seperator = false
				icon_image_html = (
					<Fragment>
						{ "none" !== seperatorStyle && seperator_html }
						{ is_image }
					</Fragment>
				)
			}
			// Get description and seperator components.
			const desc = (
				<Fragment>
					{ "none" !== seperatorStyle && ( seperator_position == "after_title"  && show_seperator )&& seperator_html }
					<div className = "wpsp-ifb-text-wrap">
						{ showDesc && "" !== headingDesc && <HowToChildDesc attributes={props.attributes} setAttributes = "not_set"/> }
						{ "none" !== seperatorStyle && seperator_position == "after_desc" && seperator_html }
						{ ctaType !== "none" && <CallToAction attributes={props.attributes} />}
					</div>
				</Fragment>
			)

			// Get Title components.
			const title_text = (
				<div className = "wpsp-ifb-title-wrap">
					{ "none" !== seperatorStyle && seperator_position == "after_prefix" && seperator_html }
					{ showTitle && "" !== howtoChildTitle && <Title attributes={ props.attributes} setAttributes = "not_set"/> }
				</div>
			)

			const output = (
				<div className = { classnames(
					"wpsp-how-to__content-wrap",
					( ctaType == "all" ? " wpsp-how-to_cta-type-all" : "" ),
					...HowToChildPositionClasses(  props.attributes  ),
				) }>
						<div className = "wpsp-ifb-content">

							{ ( iconimgPosition === "above-title") &&
								<Fragment>
									{ icon_image_html }
									{ title_text }
									{ desc }
								</Fragment>
							}

							{ ( iconimgPosition === "below-title") &&
								<Fragment>
									{ title_text }
									{ icon_image_html }
									{ desc }
								</Fragment>
							}

							{ ( iconimgPosition === "below-desc") &&
								<Fragment>
									{ title_text }
									{ desc }
									{ icon_image_html }
								</Fragment>
							}
						</div>
				</div>
			)

			let target =""
			if( ctaTarget ){
				target ="_blank"
			}

			return (
				<div className={ classnames(
					className,
					"wpsp-howto-child__outer-wrap",
					`wpsp-block-${block_id}`
				) }>

					{ ( ctaType == "all") &&
						<a href= {ctaLink} className = "wpsp-howto-child-link-wrap wpsp-how-to__link-to-all" target={target} aria-label={"HowToChild Link"} rel ="noopener noreferrer"></a>
					}
					{output}
				</div>
			)
        }
    },
]

export default deprecated;
